import React from 'react';
import styles from '@buddieshr/styles/components/arguments.module.scss';
import Image from 'next/image';
import { Tag } from 'antd';

const Argument = ({
  reverse,
  title,
  name,
  description,
  pictureUrl,
  rightContent,
  logoUrl,
  videoUrl,
  pictureStyle = {},
  id,
  background,
  pictureLegend,
  tag,
  className,
}) => (
  <div
    id={id}
    className={`${styles.wrapper}${className ? ` ${className}` : ''}`}
    style={background ? { background: background } : {}}
  >
    <div className={`${styles.inner} ${reverse ? styles.reverse : ''}`}>
      <div className={styles.left}>
        <div>
          {logoUrl && (
            <>
              <Image
                className={styles.logo}
                src={logoUrl}
                width={80}
                height={80}
                alt={title}
              />
            </>
          )}
          {tag && (
            <div className={styles.tag}>
              <Tag
                color="blue"
                size="large"
                style={{
                  fontSize: 15,
                  padding: '4px 16px',
                  fontWeight: 'bold',
                }}
              >
                {tag}
              </Tag>
            </div>
          )}
          <div className={styles.name}>{name}</div>
          <h2 className={styles.title}>{title}</h2>
          <div className={styles.desc}>{description}</div>
        </div>
      </div>
      <div className={styles.right}>
        {videoUrl ? (
          <video
            className={styles.image}
            src={videoUrl}
            width={760}
            style={{
              maxWidth: '100%',
            }}
            autoPlay={true}
            muted={true}
            playsInline
            loop={true}
            preload="auto"
            alt="praise, kudos and recognitions in slack"
          />
        ) : pictureUrl ? (
          <>
            <Image
              className={styles.image}
              src={pictureUrl}
              width={420}
              height={420}
              alt={title}
              style={pictureStyle}
            />
            {pictureLegend && (
              <div className={styles.pictureLegend}>{pictureLegend}</div>
            )}
          </>
        ) : rightContent ? (
          <div>{rightContent}</div>
        ) : (
          <div className={styles.noPicture}>Coming soon</div>
        )}
      </div>
    </div>
  </div>
);

export default Argument;
